import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Button from 'material-ui/Button';
import Input, { InputLabel } from 'material-ui/Input';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import { DatePicker, TimePicker } from 'material-ui-pickers';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import * as regData from '../../../../appConstants'

import moment from 'moment';

import DataTable from './datatable';

import ContainerHeader from '../../../components/ContainerHeader/index';
import * as auditdetails from '../../../actions/auditdetails';


class auditList extends Component {
    constructor(props) {
        super(props)       
        this.state = {
            setValue: false,
            committee_id: Number(this.props.loginUser.data.committee_id ? this.props.loginUser.data.committee_id : 0),
            updatedFrom:  moment(new Date()).add('days', -30), 
            updatedTo:  moment(new Date()), 
            modified_by: '',
            audittype : this.props.match.params        
        }      
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }


    handleSearch(e) {
        e.preventDefault();
        // this.setState({ [name]: event.target.value });     
        this.props.actions.getauditList(this.state.audittype, {"updatedFrom": this.state.updatedFrom.format('YYYY/MM/DD'),"updatedTo": this.state.updatedTo.format('YYYY/MM/DD'),"modified_by":this.state.modified_by});
    };

    handleChange(event){      
        this.setState({ [event.target.name]: event.target.value });       
    };

    handleDateChange(name, date){
        //this.setState({ [name]: date});
        //this.setState({updatedFrom: moment(date)});       
        this.setState(Object.assign({}, this.state, {[name]:moment(date)}));        
    };

    componentWillMount(){
      
    }

    componentDidMount() {
        // console.log('componentDidMount')
        // console.log('props', this.state.audittype)      
        this.props.actions.getauditList(this.state.audittype, {"updatedFrom": this.state.updatedFrom.format('YYYY/MM/DD'),"updatedTo": this.state.updatedTo.format('YYYY/MM/DD'),"modified_by":this.state.modified_by});
    }

    render() {
        const { auditDetails, match, loginUser } = this.props;
        const { audittype } = this.props.match.params;         
        let dataList = <tr><td></td></tr>;
        let message = null;    
        // console.log('this.state.setValue', this.state.setValue);
        if ((auditDetails && auditDetails.Status) || (auditDetails && auditDetails.actionStatus)) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }

        var title;
        if( audittype == 'user'){            
            title = "User List";
 
         } else if(audittype == 'meeting'){         
            title = "Meeting List";
         } else if(audittype == 'agenda'){         
            title = "Agenda List";
         } else if(audittype == 'folder'){         
            title = "Folder List";
         }  else if(audittype == 'resolutions'){         
            title = "Resolution List";
         }       else if(audittype == 'decisions'){
            title = "Decisions List";
         }  
         else if(audittype == 'AgendaFile'){
            title = "Agenda File List";
         }  
         else if(audittype == 'folderFile'){
            title = "Folder File List";
         } 
         else if(audittype == 'resolutionFile'){
            title = "Resolution File List";
         }     

        return (
           
     
            <div className="slideInUpTiny ">
                {message}
                <ContainerHeader title={title} match={match} />                
                    <div className="col-12">
                        <div className="row">
                        <div className="col-12 p-0">
                            <ValidatorForm autoComplete="off" onSubmit={this.handleSearch}>
                                <Card className="shadow border-0">

                                    <CardBody>
                                        <div className="row">                                       
                                            <div className="col-3">
                                                <DatePicker fullWidth value={this.state.updatedFrom}
                                                    name="updatedFrom"
                                                    onChange={this.handleDateChange.bind(this,"updatedFrom")}
                                                    animateYearScrolling={false} label="Start Date"
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                    format="DD/MM/YYYY"
                                                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />} rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />} />
                                            </div>
                                            <div className="col-3">
                                                <DatePicker fullWidth value={this.state.updatedTo}
                                                    name="updatedTo"
                                                    onChange={this.handleDateChange.bind(this,"updatedTo")}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                    animateYearScrolling={false} label="End Date"
                                                    format="DD/MM/YYYY"
                                                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />} rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />} />
                                            </div>
                                            <div className="col-3">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="modified_by" label="Created By"
                                                validators={[regData.regexAlphaNumeric ,regData.regexAlphaNumericLength]}
                                                errorMessages={[regData.messageAlphaNumeric,regData.messageLength]}                                             
                                                onChange={this.handleChange}
                                                value={this.state.modified_by} />
                                            </div>
                                            <div className="col-3 text-right pt-3">
                                                <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Search</Button>
                                            </div> </div>

                                    </CardBody>
                                </Card>
                            </ValidatorForm></div>
                            </div>
                            <div className="row">
                                <div className="col-12 p-0">
                                    <h4 className="bg-primary text-white p-3 mb-0">{title}</h4>
                                    <DataTable data={auditDetails && auditDetails.auditdetails && auditDetails.auditdetails.length > 0 ? auditDetails.auditdetails : null}
                                        committee_id={this.state.committee_id} loggedinUserRole_id={loginUser.data.role_id} audittype={audittype} />
                                </div>
                            </div>                        
                    </div>
                </div>           
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { auditDetails, loginUser } = state
    const { match } = ownProps
    return { auditDetails, match, loginUser }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, auditdetails), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(auditList);



// WEBPACK FOOTER //
// ./app/auditdetails/AuditList/index.js